import React from "react";
import { Link } from "react-router-dom";
import styles from "./EmptyCartView.module.css";

const EmptyCart = (): JSX.Element => {
  return (
    <div className={`container ${styles.container}`}>
      <div className={styles.emptyCartContent}>
        <div className={styles.svgContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className={styles.svg}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </div>
        <h2 className={styles.heading}>¡Tu carrito está vacío!</h2>
        <p className={styles.paragraph}>
          Antes de pedir debes agregar algunos productos a tu carrito de
          compras. Encontrarás todo lo que necesitas para celebrar en nuestra
          página.
        </p>
        <Link to="/" className={`buttonMain ${styles.button}`}>
          Comienza a Comprar
        </Link>
      </div>
    </div>
  );
};

export default EmptyCart;
